import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import { init as initRelay } from "../../../../init-relay-streaming";
import { ConfluenceTemplatesRelayPage } from "../../../../pages/software/confluence/templates/confluence-templates-contentful-relay-page";
import {
    ConfluenceTemplatesUnifiedRelayPageQuery,
    getConfluenceTemplatesUnifiedRelayPageQueryVars
} from "../../../../templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-templates-unified-contentful-relay-page.template";

initRelay(
    ConfluenceTemplatesRelayPage,
    ConfluenceTemplatesUnifiedRelayPageQuery,
    getConfluenceTemplatesUnifiedRelayPageQueryVars(window.location),
    RELAY_API_CONTENTFUL
);
